/* istanbul ignore file */
import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { Logger, NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';

import { BaseBexApiStore } from './bex-api-store';
import analyticsWrapper from 'utility/analytics-wrapper';
import { FlightsShoppingPwaFlightServicingResults, Sdk } from '__generated__/api/';

export class FlightServicingStore extends BaseBexApiStore {
  public hydrate(data: SerializedData): void {
    super.hydrate(data);
  }

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, api: Sdk) {
    super(state, logger, api);
  }

  public fetchResults(
    servicingVariables: FlightsShoppingPwaFlightServicingResults.Variables,
    options: HeadersInit,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightServicingResults.FlightsServicing> {
    return this.api
      .FlightsShoppingPwaFlightServicingResults(servicingVariables, options)
      .then(response => {
        const { flightsServicing } = response?.data ?? {};

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsServicing
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'SERVICING_FETCH'), error);

        return null;
      });
  }
}

FlightServicingStore.DEFAULTS = {};
